import PropTypes from 'prop-types';
import wasPriceType from './was-price-type';

const productType = PropTypes.shape({
  category_title: PropTypes.string,
  design_code: PropTypes.string,
  flag: PropTypes.number,
  id: PropTypes.number,
  images: PropTypes.arrayOf(PropTypes.string),
  is_card: PropTypes.bool,
  price: PropTypes.number,
  price_range: PropTypes.arrayOf(PropTypes.number),
  stacked: PropTypes.bool,
  theme_name: PropTypes.string,
  theme_title: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  was_price: PropTypes.oneOfType([
    wasPriceType,
    PropTypes.arrayOf(wasPriceType),
  ]),
});

export default productType;
